import { errorTypeLabel } from 'views/OptimiserStatus/config';

// Filter a flat violations array to a single record. Coerces both sides to
// Number so string ids (from Redux) and numeric ids (from the API) match.
export const filterViolationsForRecord = (results, recordId, recordType = 'user') => {
  if (!results || !results.length) return [];
  const id = Number(recordId);
  return results.filter(
    v => v.record_type === recordType && Number(v.record_id) === id
  );
};

// Maps violations to short display strings for the inline warning list.
export const formatMissingItems = (violations) => {
  if (!violations || !violations.length) return [];
  return violations.map(v => `${errorTypeLabel(v.error_type)}: ${v.detail}`);
};
